import { SPECIAL_AGENT_IDS } from './agent-ids.constants';

/**
 * Whether the given agent id drives an audience-interview session.
 *
 * The id comes straight from the chat store, which can hold no agent for a render while a switch is
 * in flight, so a missing id is simply not an interview.
 */
export function useIsInterviewSession(currentAgentId: string | null | undefined): boolean {
  return (
    currentAgentId === SPECIAL_AGENT_IDS.AUDIENCE_FLOW ||
    (currentAgentId?.startsWith(SPECIAL_AGENT_IDS.AUDIENCE_FLOW_PERSONA_PREFIX) ?? false)
  );
}
